export default "__VITE_ASSET__DNF4x4cd__"